export const SDK_VERSION = '7.35.0';
